webpackJsonp([156754302151026],{

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.newBooking = newBooking;
	
	var _actionTypes = __webpack_require__(2);
	
	var _index = __webpack_require__(7);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function newBooking(token, event, note, membres, date, groupe, callback1, callback2) {
	  var data = {
	    note: note,
	    membres: membres,
	    groupe: groupe,
	    date: date
	  };
	
	  event === 'null' ? undefined : data.event = event;
	
	  return function (dispatch) {
	    dispatch({ type: _actionTypes.NEW_BOOKING_REQUEST });
	
	    return (0, _index2.default)({
	      url: ("https://api.gas.tn") + '/booking',
	      method: 'post',
	      headers: {
	        Accept: 'application/json',
	        'Content-Type': 'application/json',
	        Authorization: 'Bearer ' + token
	      },
	      data: data
	    }).then(function (response) {
	      dispatch({ type: _actionTypes.NEW_BOOKING_SUCCESS, payload: response.data });
	      callback1();
	    }).catch(function (error) {
	      dispatch({ type: _actionTypes.NEW_BOOKING_FAILURE, payload: error });
	      callback2();
	    });
	  };
	}

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getMenuBySlug = getMenuBySlug;
	
	var _axios = __webpack_require__(7);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actionTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getMenuBySlug(slug) {
	  return function (dispatch) {
	    dispatch({ type: _actionTypes.FETCH_MENUS_REQUEST });
	    return (0, _axios2.default)({
	      url: ("https://api.gas.tn") + '/menu/menus?slug=' + slug,
	      method: 'get'
	    }).then(function (response) {
	      dispatch({ type: _actionTypes.FETCH_MENUS_SUCCESS, payload: response.data });
	    }).catch(function (error) {
	      dispatch({ type: _actionTypes.FETCH_MENUS_FAILURE, payload: error });
	    });
	  };
	}

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getWeather = getWeather;
	
	var _axios = __webpack_require__(7);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actionTypes = __webpack_require__(2);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getWeather() {
	  return function (dispatch) {
	    dispatch({ type: actionTypes.FETCH_WEATHER_REQUEST });
	    var url = 'https://api.openweathermap.org/data/2.5/forecast?q=Sousse,TN&units=metric&appid=6c3bdc3338b040e3eac2036dbc6ac321';
	    _axios2.default.get(url).then(function (res) {
	      var dayOne = bringWeatherDay(res.data.list, 0, 4);
	      var dayTwo = bringWeatherDay(res.data.list, 4, 12);
	      var dayThree = bringWeatherDay(res.data.list, 12, 20);
	      var dayFour = bringWeatherDay(res.data.list, 20, 28);
	      var dayFive = bringWeatherDay(res.data.list, 28, 36);
	      var daySix = bringWeatherDay(res.data.list, 36, 40);
	      dispatch({
	        type: actionTypes.FETCH_WEATHER_SUCCESS,
	        payload: {
	          weather: res.data,
	          dayOne: [].concat(dayOne),
	          dayTwo: [].concat(dayTwo),
	          dayThree: [].concat(dayThree),
	          dayFour: [].concat(dayFour),
	          dayFive: [].concat(dayFive),
	          daySix: [].concat(daySix)
	        }
	      });
	    }).catch(function (e) {
	      dispatch({ type: actionTypes.FETCH_WEATHER_FAILURE, payload: e });
	    });
	  };
	}
	
	function bringWeatherDay(list, begin, end) {
	  return list.slice(begin, end);
	}

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMjIuMS4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FscXVlXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMDAgNDAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMDAgNDAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGQ9Ik05NS4yNDIsMTc4LjI4NUg0My45MzloLTcuMDE3di03LjAxOFY4NS4wMzZoMTQuMDM1djc5LjIxNGg0NC4yODVWMTc4LjI4NUw5NS4yNDIsMTc4LjI4NXoKCQkgTTE2My4wNzksMTc4LjI4NWgtNDYuNjI0aC03LjAxOHYtNy4wMThWOTIuMDUzdi03LjAxOGg3LjAxOGg0Ni42MjR2MTQuMDM1aC0zOS42MDd2MjUuNTcyaDM5LjYwN3YxNC4wMzVoLTM5LjYwN3YyNS41NzJoMzkuNjA3CgkJVjE3OC4yODVMMTYzLjA3OSwxNzguMjg1eiBNNjkuOTkzLDIzNS44MTlsMTkuODAzLDM5LjYwN2w1LjA3MSwxMC4xNDNIODMuNTQ2SDYzLjc0Mkg0My45MzloLTcuMDE3di03LjAxOHYtNzkuMjE0di03LjAxOGg3LjAxNwoJCWgxOS44MDRoMjQuNDgyaDcuMDE4djcuMDE4djM5LjYwN0g4MS4yMDZ2LTMyLjU4OUg2My43NDJINTAuOTU3djY1LjE3OWgxMi43ODZoOC40ODNMNTcuNDkzLDI0Mi4wN0w2OS45OTMsMjM1LjgxOUw2OS45OTMsMjM1LjgxOQoJCXogTTE2My4wNzksMjA2LjM1NWgtMzkuNjA3djY1LjE3OWgxMi43ODVoMTIuNzg2di0yNS41NzJoLTEyLjc4NnYtMTQuMDM1aDE5LjgwNGg3LjAxOHY3LjAxOHYzOS42MDd2Ny4wMThoLTcuMDE4aC0xOS44MDRoLTE5LjgwMgoJCWgtNy4wMTh2LTcuMDE4di03OS4yMTR2LTcuMDE4aDcuMDE4aDQ2LjYyNFYyMDYuMzU1TDE2My4wNzksMjA2LjM1NXogTTU0LjQyNSwzMjAuNjU3SDMxLjYzOEg4Ljg1MkgxLjgzM3YtNy4wMThWNTYuOTY1di03LjAxOAoJCWg3LjAxOGgxODIuMjk3aDcuMDE4djcuMDE4djEyOC4zMzdWMzEzLjY0djcuMDE4aC03LjAxOGgtMjIuNzg4aC0yMi43ODd2LTE0LjAzNWgyMi43ODdoMTUuNzd2LTEyMS4zMlY2My45ODNIMTUuODY5djI0Mi42MzkKCQloMTUuNzY5aDIyLjc4N1YzMjAuNjU3TDU0LjQyNSwzMjAuNjU3eiBNNTcuMjQ2LDMzOS42MTZsMTkuNjM4LTE5LjYzOGwzLjQ3OC0zLjQ3OWwzLjQ3OSwzLjQ3OUwxMDAsMzM2LjEzN2wxNi4xNTktMTYuMTU5CgkJbDMuNDc5LTMuNDc5bDMuNDc4LDMuNDc5bDE5LjYzOCwxOS42MzhsLTYuOTU3LDYuOTU4bC0xNi4xNTktMTYuMTU5bC0xNi4xNTksMTYuMTU5TDEwMCwzNTAuMDUybC0zLjQ3OS0zLjQ3OWwtMTYuMTU5LTE2LjE1OQoJCWwtMTYuMTU5LDE2LjE1OUw1Ny4yNDYsMzM5LjYxNkw1Ny4yNDYsMzM5LjYxNnoiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/weather-clear-sky-night.476485e3.svg";

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/weather-few-clouds-night.d5c9d465.svg";

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Panel = __webpack_require__(53);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu(props) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      activeTab: 0
	    };
	
	    _this.activateTab = _this.activateTab.bind(_this);
	    return _this;
	  }
	
	  Menu.prototype.activateTab = function activateTab(index) {
	    this.setState(function (prev) {
	      return {
	        activeTab: prev.activeTab === index ? -1 : index
	      };
	    });
	  };
	
	  Menu.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'menu-' + this.props.color + ' ' + this.props.background, id: 'menu' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container pb-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'align-items-center pt-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'txt-bold-40px mb-4 txt-uppercase txt-' + this.props.color },
	            'Menu'
	          ),
	          this.props.data.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'accordion offset-md-1 col-md-10', role: 'tablist' },
	              this.props.data.map(function (item, index) {
	                return _react2.default.createElement(_Panel2.default, _extends({
	                  key: index,
	                  activeTab: _this2.state.activeTab,
	                  index: index,
	                  activateTab: _this2.activateTab.bind(null, index),
	                  color: _this2.props.color
	                }, item));
	              })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'pt-5 pb-5 txt-white' },
	            _react2.default.createElement('span', { className: 'fas fa-circle-o-notch fa-5x fa-spin' })
	          )
	        )
	      )
	    );
	  };
	
	  return Menu;
	}(_react.Component);
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _facebookTools = __webpack_require__(22);
	
	var _key = __webpack_require__(63);
	
	var _key2 = _interopRequireDefault(_key);
	
	var _profile = __webpack_require__(47);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _loginAction = __webpack_require__(36);
	
	var _reactstrap = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuthModal = function (_Component) {
	  _inherits(AuthModal, _Component);
	
	  function AuthModal(props) {
	    _classCallCheck(this, AuthModal);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      modal: true,
	      error: false
	    };
	    _this.toggle = _this.toggle.bind(_this);
	    _this.responseFacebook = _this.responseFacebook.bind(_this);
	    return _this;
	  }
	
	  AuthModal.prototype.toggle = function toggle() {
	    var _this2 = this;
	
	    this.setState({
	      modal: !this.state.modal
	    }, function () {
	      return _this2.props.ToggleModal();
	    });
	  };
	
	  AuthModal.prototype.goToLogin = function goToLogin() {
	    var _this3 = this;
	
	    this.props.loginFacebook(this.state.AccessToken, function () {
	      _this3.toggle();
	    }, function () {
	      _this3.setState({
	        errorLogin: true
	      });
	    });
	  };
	
	  AuthModal.prototype.FormAuth = function FormAuth(e) {
	    var _this4 = this;
	
	    e.preventDefault();
	    this.props.signIn(document.getElementById('username').value, document.getElementById('password').value, function () {
	      _this4.toggle();
	    }, function () {
	      return _this4.setState({
	        errorLogin: true
	      });
	    });
	  };
	
	  AuthModal.prototype.responseFacebook = function responseFacebook(response) {
	    var _this5 = this;
	
	    this.setState({
	      AccessToken: response.accessToken
	    }, function () {
	      _this5.goToLogin();
	    });
	  };
	
	  AuthModal.prototype.render = function render() {
	    var _this6 = this;
	
	    return _react2.default.createElement(
	      _reactstrap.Modal,
	      {
	        isOpen: this.state.modal,
	        toggle: this.toggle,
	        className: 'txt-white pt-x',
	        external: _react2.default.createElement(
	          'button',
	          { className: 'close', style: { position: 'absolute', top: 25, right: 25, color: 'white' } },
	          _react2.default.createElement('span', { className: 'fas fa-times' })
	        )
	      },
	      _react2.default.createElement(
	        _reactstrap.ModalBody,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'pt-3 pb-3 text-center' },
	          _react2.default.createElement(
	            'form',
	            { className: 'row mb-3', onSubmit: function onSubmit(e) {
	                return _this6.FormAuth(e);
	              } },
	            _react2.default.createElement(
	              'h2',
	              { className: 'col-12 text-center mb-5' },
	              'Authentification'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 mb-3 row' },
	              _react2.default.createElement('img', { className: 'col-2', src: _profile2.default, style: { height: 20, marginTop: 15 } }),
	              _react2.default.createElement('input', { id: 'username', className: 'input-login col-10', placeholder: 'E-mail', name: 'Email', type: 'email', required: true })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 mb-3 row' },
	              _react2.default.createElement('img', { className: 'col-2', src: _key2.default, style: { height: 20, marginTop: 15 } }),
	              _react2.default.createElement('input', {
	                id: 'password',
	                className: 'input-login col-10 mb-3',
	                placeholder: 'Password',
	                name: 'Password',
	                type: 'password',
	                required: true
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row' },
	              _react2.default.createElement('div', { className: 'offset-2' }),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn-custom btn-silver col-4', type: 'submit', name: 'login' },
	                'Se connecter'
	              ),
	              _react2.default.createElement('div', { className: 'offset-1' }),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/login', className: 'btn-custom btn-purple col-4' },
	                'S\'inscrire'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row', hidden: !this.state.errorLogin },
	            _react2.default.createElement(
	              _reactstrap.Alert,
	              { color: 'danger', className: 'offset-2 col-8' },
	              'L\'email ou le mot de passe entr\xE9 est incorrect.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row text-center', style: { height: 50, justifyContent: 'between' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 text-center' },
	              'Ou'
	            )
	          ),
	          _react2.default.createElement(_facebookTools.Button, { scope: 'public_profile,email', callback: this.responseFacebook })
	        )
	      )
	    );
	  };
	
	  return AuthModal;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(store) {
	  return {
	    token: store.login.token,
	    user: store.login.user
	  };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { loginFacebook: _loginAction.loginFacebook, signIn: _loginAction.signIn, logout: _loginAction.logout })(AuthModal);
	module.exports = exports['default'];

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactstrap = __webpack_require__(13);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BookingAction = __webpack_require__(48);
	
	var _EventsAction = __webpack_require__(23);
	
	var _ProfilAction = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookingModal = function (_Component) {
	  _inherits(BookingModal, _Component);
	
	  function BookingModal(props) {
	    _classCallCheck(this, BookingModal);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      modal: true,
	      error: false,
	      email: '',
	      phone: ''
	    };
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  BookingModal.prototype.toggle = function toggle() {
	    var _this2 = this;
	
	    this.setState({
	      modal: !this.state.modal
	    }, function () {
	      return _this2.props.ToggleModal();
	    });
	  };
	
	  BookingModal.prototype.Booking = function Booking() {
	    var _this3 = this;
	
	    this.props.updateMeBooking(this.props.token, document.getElementById('phone').value, document.getElementById('email').value, function () {
	      return _this3.props.newBooking(_this3.props.token, document.getElementById('event').value, document.getElementById('note').value, document.getElementById('members').value, document.getElementById('date').value, _this3.props.eventsBySlug[0].groupe._id, function () {
	        _this3.toggle();
	        alert('Votre réservation a été envoyée avec succes. Notre équipe vérifiera la disponibilité de votre demande et répondra par téléphone ou par email dans les plus brefs délais.');
	      }, function () {
	        _this3.setState({
	          error: true
	        });
	      });
	    });
	  };
	
	  BookingModal.prototype.render = function render() {
	    var email = this.props.user.local && this.props.user.local.email ? this.props.user.local.email : this.props.user.facebook && this.props.user.facebook.email ? this.props.user.facebook.email : null;
	    return _react2.default.createElement(
	      _reactstrap.Modal,
	      {
	        isOpen: this.state.modal,
	        toggle: this.toggle,
	        className: 'txt-white pt-x',
	        external: _react2.default.createElement(
	          'button',
	          { className: 'close', style: { position: 'absolute', top: 25, right: 25, color: 'white' } },
	          _react2.default.createElement('span', { className: 'fas fa-times' })
	        )
	      },
	      _react2.default.createElement(
	        _reactstrap.ModalBody,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'row mb-3' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'col-12 text-center mb-4' },
	            'Reservation'
	          ),
	          this.props.eventsBySlug ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-3 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'fas fa-tag' })
	            ),
	            _react2.default.createElement(
	              'select',
	              { className: 'input-login col-10', id: 'event', name: 'event', form: 'event' },
	              _react2.default.createElement(
	                'option',
	                { value: 'null', disabled: true, selected: true },
	                'Reservation hors \xE9v\xE9nements...'
	              ),
	              this.props.eventsBySlug.map(function (item) {
	                return (0, _moment2.default)().isAfter(item.date) || _react2.default.createElement(
	                  'option',
	                  { value: item._id },
	                  item.name
	                );
	              })
	            )
	          ) : _react2.default.createElement(_react.Fragment, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'fas fa-users' })
	            ),
	            _react2.default.createElement('input', {
	              id: 'members',
	              className: 'input-login col-10',
	              placeholder: 'Nombre des places',
	              type: 'number',
	              name: 'Nombre des places'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'far fa-calendar-alt' })
	            ),
	            _react2.default.createElement('input', { type: 'datetime-local', id: 'date', className: 'input-login col-10', name: 'date', min: new Date() })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'far fa-comment-alt' })
	            ),
	            _react2.default.createElement('textarea', { className: 'col-10 input-login', id: 'note', placeholder: 'Note' })
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Alert,
	          { color: 'info' },
	          _react2.default.createElement('span', { className: 'fas fa-info-circle', style: { marginRight: 5 } }),
	          'Vous devez rev\xE9rifier votre num\xE9ro de t\xE9l\xE9phone et votre courrier \xE9lectronique, car nous les utilisons pour r\xE9pondre \xE0 votre demande.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 mb-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'fas fa-phone' })
	            ),
	            _react2.default.createElement('input', {
	              id: 'phone',
	              required: true,
	              defaultValue: this.props.user.phone ? this.props.user.phone : '',
	              className: 'input-login col-10',
	              placeholder: 'Num\xE9ro du t\xE9l\xE9phone',
	              type: 'tel',
	              name: 'Num\xE9ro du t\xE9l\xE9phone'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 mb-2 row' },
	            _react2.default.createElement(
	              'span',
	              { className: 'col-2', style: { height: 20, marginTop: 15 } },
	              _react2.default.createElement('span', { className: 'far fa-envelope-open' })
	            ),
	            _react2.default.createElement('input', {
	              id: 'email',
	              required: true,
	              defaultValue: email || '',
	              className: 'input-login p-2 col-10',
	              placeholder: 'Email',
	              type: 'email',
	              name: 'Email',
	              disabled: email
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 row' },
	          _react2.default.createElement('div', { className: 'col-2' }),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn-custom btn-silver col-4', onClick: this.toggle },
	            'Annuler'
	          ),
	          _react2.default.createElement('div', { className: 'col-2' }),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn-custom btn-purple col-4', onClick: this.Booking.bind(this) },
	            'Confirmer'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'row', hidden: !this.state.error },
	          _react2.default.createElement(
	            _reactstrap.Alert,
	            { color: 'danger', className: 'offset-2 col-8' },
	            'La r\xE9servation a \xE9t\xE9 echou\xE9e.'
	          )
	        )
	      )
	    );
	  };
	
	  return BookingModal;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(store) {
	  return {
	    user: store.login.user,
	    token: store.login.token
	  };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getEvents: _EventsAction.getEvents, newBooking: _BookingAction.newBooking, updateMeBooking: _ProfilAction.updateMeBooking })(BookingModal);
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Panel = function (_Component) {
	  _inherits(Panel, _Component);
	
	  function Panel(props) {
	    _classCallCheck(this, Panel);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      height: 0
	    };
	    return _this;
	  }
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        products = _props.products,
	        name = _props.name,
	        activeTab = _props.activeTab,
	        index = _props.index,
	        activateTab = _props.activateTab;
	
	    var isActive = activeTab === index;
	    var innerStyle = {
	      height: isActive ? 'auto' : '0px'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'panel menu-item-' + this.props.color, role: 'tabpanel', 'aria-expanded': isActive },
	      _react2.default.createElement(
	        'button',
	        { className: 'panel-label', role: 'tab', onClick: activateTab },
	        name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'panel-inner', style: innerStyle, 'aria-hidden': !isActive },
	        products.map(function (product) {
	          return _react2.default.createElement(
	            'div',
	            { key: product._id, className: 'row m-2' },
	            _react2.default.createElement(
	              'span',
	              { className: (product.price > 0 ? 'col-9' : 'col-12') + ' text-left' },
	              product.name
	            ),
	            product.price > 0 && _react2.default.createElement(
	              'span',
	              { className: 'col-3 text-right txt-bold' },
	              product.price + 'TND'
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return Panel;
	}(_react.Component);
	
	exports.default = Panel;
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _weather = __webpack_require__(95);
	
	var _weatherClearSky = __webpack_require__(144);
	
	var _weatherClearSky2 = _interopRequireDefault(_weatherClearSky);
	
	var _weatherClearSkyNight = __webpack_require__(143);
	
	var _weatherClearSkyNight2 = _interopRequireDefault(_weatherClearSkyNight);
	
	var _weatherFewClouds = __webpack_require__(146);
	
	var _weatherFewClouds2 = _interopRequireDefault(_weatherFewClouds);
	
	var _weatherFewCloudsNight = __webpack_require__(145);
	
	var _weatherFewCloudsNight2 = _interopRequireDefault(_weatherFewCloudsNight);
	
	var _weatherScatteredClouds = __webpack_require__(148);
	
	var _weatherScatteredClouds2 = _interopRequireDefault(_weatherScatteredClouds);
	
	var _weatherRain = __webpack_require__(147);
	
	var _weatherRain2 = _interopRequireDefault(_weatherRain);
	
	var _moment = __webpack_require__(15);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Weather = function (_Component) {
	  _inherits(Weather, _Component);
	
	  function Weather(props) {
	    _classCallCheck(this, Weather);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  Weather.prototype.componentDidMount = function componentDidMount() {
	    this.props.getWeather();
	  };
	
	  Weather.prototype.render = function render() {
	    var dayOne = this.props.weather.dayOne;
	
	    var day = dayOne;
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      day && day.length > 0 ? _react2.default.createElement(
	        'section',
	        { className: 'pt-4 ' + this.props.background, id: 'weather' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container mb-5 mt-5', style: { fontSize: 20 } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row justify-content-between' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-4 txt-regular mt-md-4 mt-sm-0 text-md-left text-sm-center' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'txt-bold' },
	                    'Tunisie, '
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'txt-thin' },
	                    'Sousse'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'txt-thin' },
	                    (0, _moment2.default)(new Date()).format('ddd DD MMM YYYY')
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-4 txt-regular text-sm-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-12 mt-sm-5' },
	                      _react2.default.createElement(WeatherCondition, { large: true, day: day[0].sys.pod, weatherCondition: day[0].weather[0].description })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'col-6 txt-regular' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'txt-regular' },
	                        'Humidit\xE9'
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'txt-thin' },
	                        day[0].main.humidity,
	                        '%'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'col-6 txt-regular text-sm-center' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'txt-regular' },
	                        'Vent'
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'txt-thin' },
	                        day[0].wind.speed,
	                        'Km/h'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-4 text-md-right text-sm-center' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'txt-bold txt-white live-temperature' },
	                    Math.trunc(day[0].main.temp_max),
	                    _react2.default.createElement(
	                      'sup',
	                      { style: { fontSize: 20 } },
	                      'C\xB0 ',
	                      _react2.default.createElement(
	                        'span',
	                        { style: { fontSize: 15 } },
	                        'max'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'txt-bold txt-white live-temperature' },
	                    Math.trunc(day[0].main.temp_min),
	                    _react2.default.createElement(
	                      'sup',
	                      { style: { fontSize: 20 } },
	                      'C\xB0 ',
	                      _react2.default.createElement(
	                        'span',
	                        { style: { fontSize: 15 } },
	                        'min'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(DayWeather, { day: day })
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'pt-5 pb-5 txt-white' },
	        _react2.default.createElement('span', { className: 'fas fa-circle-o-notch fa-5x fa-spin' })
	      )
	    );
	  };
	
	  return Weather;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(store) {
	  return {
	    weather: store.weather
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, { getWeather: _weather.getWeather })(Weather);
	
	
	var DayWeather = function DayWeather(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'row justify-content-center' },
	    props.day.map(function (weatherByTime, key) {
	      return _react2.default.createElement(
	        'div',
	        { key: key, className: 'm-4 row flex-column align-items-center' },
	        _react2.default.createElement(WeatherDate, { date: weatherByTime.dt_txt }),
	        _react2.default.createElement(WeatherCondition, { day: weatherByTime.sys.pod, weatherCondition: props.day[0].weather[0].description }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'txt-regular m-1' },
	            Math.trunc(weatherByTime.main.temp_min),
	            ' \xB0'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'txt-regular m-1' },
	            Math.trunc(weatherByTime.main.temp_max),
	            ' \xB0'
	          )
	        )
	      );
	    })
	  );
	};
	
	var WeatherCondition = function WeatherCondition(props) {
	  var icon = null;
	  var day = props.day,
	      weatherCondition = props.weatherCondition;
	
	  if (weatherCondition === 'clear sky') {
	    if (day) {
	      if (day === 'd') {
	        icon = _weatherClearSky2.default;
	      } else {
	        icon = _weatherClearSkyNight2.default;
	      }
	    } else {
	      icon = _weatherClearSky2.default;
	    }
	  } else if (weatherCondition === 'few clouds') {
	    if (day) {
	      if (day === 'd') {
	        icon = _weatherFewClouds2.default;
	      } else {
	        icon = _weatherFewCloudsNight2.default;
	      }
	    } else {
	      icon = _weatherFewClouds2.default;
	    }
	  } else if (weatherCondition === 'scattered clouds') {
	    icon = _weatherScatteredClouds2.default;
	  } else if (weatherCondition === 'rain') {
	    icon = _weatherRain2.default;
	  } else {
	    icon = _weatherFewClouds2.default;
	  }
	  return _react2.default.createElement('img', { className: 'mb-2', src: icon, style: { marginLeft: 'auto', marginRight: 'auto' }, width: props.large ? 150 : 50 });
	};
	
	var WeatherDate = function WeatherDate(props) {
	  return _react2.default.createElement(
	    'span',
	    { className: 'txt-thin mb-2' },
	    ' ',
	    getHoursFromDate(new Date(props.date)),
	    ' '
	  );
	};
	
	function getHoursFromDate(date) {
	  return date.getHours() + ':00';
	}
	module.exports = exports['default'];

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutLeQG = function (_Component) {
	  _inherits(AboutLeQG, _Component);
	
	  function AboutLeQG() {
	    _classCallCheck(this, AboutLeQG);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutLeQG.prototype.render = function render() {
	    return _react2.default.createElement(
	      "section",
	      { className: this.props.background, id: "about" },
	      _react2.default.createElement(
	        "div",
	        { className: "container mt-5 mb-5" },
	        _react2.default.createElement(
	          "div",
	          { className: "row pt-2 pb-2" },
	          _react2.default.createElement(
	            "span",
	            { className: "col-12 txt-bold-40px txt-blue txt-uppercase" },
	            "Restaurant & Wine Bar"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "col-12 txt-thin" },
	            "\xC9clos en 2014, LEQG jouit d'une vue sur mer exceptionnelle, un service excellent et un accueil in\xE9gal\xE9 de son \xE9quipe dans un cadre contemporain et chaleureux. Aux beaux jours, sa terrasse vous offre un espace calme et d\xE9tach\xE9 des bruits de la rue, un endroit id\xE9al pour profiter de la journ\xE9e. A la crois\xE9e des chemins entre tradition et innovation, LEQG fait le bonheur des amoureux des douces saveurs m\xE9diterran\xE9ennes et ses sp\xE9cialit\xE9s que le chef sait accommoder en vous pr\xE9sentant des plats raffin\xE9s et d\xE9licieux."
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "col-12 txt-bold-40px txt-blue txt-uppercase" },
	            "Luxury apartments"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "col-12 txt-thin" },
	            "LEQG Luxury Apartments Sousse vous dispose des appartements de HAUT STANDING situ\xE9s au bord de la mer \xE0 la location par jour, par semaine ou par mois et b\xE9n\xE9ficiant d'un service digne d'un h\xF4tel 5 \xE9toiles."
	          )
	        )
	      )
	    );
	  };
	
	  return AboutLeQG;
	}(_react.Component);
	
	exports.default = AboutLeQG;
	module.exports = exports["default"];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BookingModal = __webpack_require__(52);
	
	var _BookingModal2 = _interopRequireDefault(_BookingModal);
	
	var _AuthModal = __webpack_require__(51);
	
	var _AuthModal2 = _interopRequireDefault(_AuthModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderWithBooking = function (_Component) {
	  _inherits(HeaderWithBooking, _Component);
	
	  function HeaderWithBooking() {
	    _classCallCheck(this, HeaderWithBooking);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.toggle = function () {
	      if (_this.props.token === null) _this.setState({ openModal: true });else _this.setState({ open: true });
	    };
	
	    _this.state = {
	      open: false,
	      openModal: false
	    };
	    return _this;
	  }
	
	  HeaderWithBooking.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'pb-3 pt-3' },
	      _react2.default.createElement(
	        'div',
	        null,
	        this.props.icon
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { onClick: this.toggle, className: 'btn-custom btn-silver' },
	          'R\xE9servation'
	        ),
	        this.state.open === true && _react2.default.createElement(_BookingModal2.default, { ToggleModal: function ToggleModal() {
	            return _this2.setState({ open: false });
	          }, eventsBySlug: this.props.eventsBooking }),
	        this.state.openModal === true && _react2.default.createElement(_AuthModal2.default, { ToggleModal: function ToggleModal() {
	            return _this2.setState({ openModal: false });
	          } })
	      )
	    );
	  };
	
	  return HeaderWithBooking;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (store) {
	  return { token: store.login.token };
	}, {})(HeaderWithBooking);
	module.exports = exports['default'];

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(5);
	
	var _scrolling = __webpack_require__(26);
	
	var _Weather = __webpack_require__(97);
	
	var _Weather2 = _interopRequireDefault(_Weather);
	
	var _AboutLeQG = __webpack_require__(259);
	
	var _AboutLeQG2 = _interopRequireDefault(_AboutLeQG);
	
	var _Gallery = __webpack_require__(29);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Header = __webpack_require__(30);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _NavigationBar = __webpack_require__(31);
	
	var _NavigationBar2 = _interopRequireDefault(_NavigationBar);
	
	var _Contact = __webpack_require__(27);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Events = __webpack_require__(65);
	
	var _Events2 = _interopRequireDefault(_Events);
	
	var _Menu = __webpack_require__(50);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenusAction = __webpack_require__(49);
	
	var _EventsAction = __webpack_require__(23);
	
	var _GallerieAction = __webpack_require__(24);
	
	var _HeaderWithBooking = __webpack_require__(54);
	
	var _HeaderWithBooking2 = _interopRequireDefault(_HeaderWithBooking);
	
	var _leqgLogo = __webpack_require__(140);
	
	var _leqgLogo2 = _interopRequireDefault(_leqgLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeQG = function (_Component) {
	  _inherits(LeQG, _Component);
	
	  function LeQG(props) {
	    _classCallCheck(this, LeQG);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      active: 0,
	      items: [],
	      images: []
	    };
	    return _this;
	  }
	
	  LeQG.prototype.componentDidMount = function componentDidMount() {
	    this.props.getGallery('leqgsousse');
	    this.props.getEventsBySlug('leqgsousse');
	
	    this.props.getMenuBySlug('leqgsousse');
	    var about = _reactDom2.default.findDOMNode(this.refs.about);
	    var events = _reactDom2.default.findDOMNode(this.refs.events);
	    var menu = _reactDom2.default.findDOMNode(this.refs.menu);
	    var weather = _reactDom2.default.findDOMNode(this.refs.weather);
	    var gallery = _reactDom2.default.findDOMNode(this.refs.gallery);
	
	    this.props.savingNodesPositions({
	      leqg: {
	        about: about.offsetTop,
	        events: events.offsetTop,
	        menu: menu.offsetTop,
	        weather: weather.offsetTop,
	        gallery: gallery.offsetTop
	      }
	    });
	  };
	
	  LeQG.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _Header2.default,
	        {
	          content: _react2.default.createElement(_HeaderWithBooking2.default, {
	            icon: _react2.default.createElement('img', { alt: 'Logo', className: 'm-2', src: _leqgLogo2.default, style: { height: 250 } }),
	            eventsBooking: this.props.events
	          }),
	          background: 'leqg-header-bg'
	        },
	        _react2.default.createElement(_NavigationBar2.default, {
	          slug: 'leqg',
	          navigations: [{ name: 'about', txt: 'About' }, { name: 'events', txt: 'Events' }, { name: 'menu', txt: 'Menu' }, { name: 'weather', txt: 'Météo' }, { name: 'gallery', txt: 'Gallery' }]
	        })
	      ),
	      _react2.default.createElement(_AboutLeQG2.default, { ref: 'about', background: 'leqg-about-bg' }),
	      _react2.default.createElement(_Events2.default, { ref: 'events', background: 'leqg-event-bg', showPlace: true, data: this.props.events }),
	      _react2.default.createElement(_Menu2.default, { ref: 'menu', background: 'leqg-menu-bg', color: 'blue', data: this.props.menus }),
	      _react2.default.createElement(_Weather2.default, { ref: 'weather', background: 'leqg-weather-bg' }),
	      _react2.default.createElement(_Gallery2.default, { ref: 'gallery', background: 'leqg-gallery-bg', medias: this.props.gallerie }),
	      _react2.default.createElement(_Contact2.default, { ref: 'contact', minimal: true, color: '#016fc5', placeholders: '#39a3fe', background: 'leqg-about-bg', info: info }),
	      _react2.default.createElement(_Footer2.default, { color: '#016fc5', secondColor: '#39a3fe' })
	    );
	  };
	
	  return LeQG;
	}(_react.Component);
	
	var info = {
	  facebook: 'https://www.facebook.com/leqgsousse/',
	  insta: 'https://www.instagram.com/explore/locations/547878854/le-qg/',
	  youtube: '',
	  tripAdvisor: 'https://www.tripadvisor.fr/Restaurant_Review-g1189197-d7686268-Reviews-Le_Qg-Hammam_Sousse_Sousse_Governorate.html',
	  address: _react2.default.createElement(
	    'span',
	    null,
	    'Golf Advanced Services, Port El Kantaoui,Hammam Sousse,4089 ',
	    _react2.default.createElement('br', null),
	    'Si\xE9ge social : A 6-4,Immeuble Venus, centre Urbain Nord, 1003 Tunis.'
	  )
	};
	
	exports.default = (0, _reactRedux.connect)(function (store) {
	  return {
	    scrolling: store.scrolling,
	    menus: store.menus,
	    gallerie: store.gallerie,
	    events: store.events
	  };
	}, {
	  savingNodesPositions: _scrolling.savingNodesPositions,
	  getMenuBySlug: _MenusAction.getMenuBySlug,
	  getEventsBySlug: _EventsAction.getEventsBySlug,
	  getGallery: _GallerieAction.getGallery
	})(LeQG);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-leqg-jsx-f3017ce5ae23494f884a.js